import { RootState } from '@/store/main';

export const getChannels = (state: RootState) => state.channels.channels;
export const getIsLoadingChannels = (state: RootState) => state.channels.loadingChannels;
export const selectUpdateChannelError = (state: RootState) => state.channels.updateChannelError;
